<template>
  <div class="dt-page login-page">
    <div class="login-container">
      <v-card class="dt-modal login-card">
        <div class="dt-modal--header">
          <img
            class="company-logo"
            :src="`https://detailss3web.s3.amazonaws.com/images/logo/${this.clientName}logo`"
            alt
          />
        </div>

        <div class="dt-modal--body">
          <h3 v-if="sharedLogin" style="font-weight: bold">
            {{ $t("session_expired") }}
          </h3>
          <button
            v-if="sharedLogin"
            class="dt-button v4 s1"
            @click.stop="loginAgain"
            style="height: 40px; margin: 10px 0px 15px 0px"
          >
            <span>{{ $t("log_in_again") }}</span>
          </button>
          <h2 v-if="sharedLogin" style="text-align: center; margin: 8px 0px">
            {{ $t("login_as") }}
          </h2>
          <form class="form-group">
            <TextField
              ref="usernameTextfield"
              class="m1"
              :id="'username'"
              required
              :value="loginUser.username"
              v-bind="textFieldConfig"
              :placeholder="'Username'"
              :disabled="
                (loginUser.loading || loginUser.success) && !sharedLogin
              "
              @valuechanged="onTextFieldValueChange"
              @validated="onValidation"
            ></TextField>
            <TextField
              ref="passwordTextfield"
              class="m1"
              :id="'password'"
              required
              password
              v-bind="textFieldConfig"
              :value="loginUser.password"
              :placeholder="'Password'"
              :disabled="
                (loginUser.loading || loginUser.success) && !sharedLogin
              "
              @valuechanged="onTextFieldValueChange"
              @validated="onValidation"
            ></TextField>
            <!-- <input type="text" name="username" id="username" v-model="loginUser.username">
            <input type="password" name="password" id="password" v-model="loginUser.password">-->
            <!-- <input type="submit" value="Log In" /> -->
            <!-- {{loginUser}} -->
          </form>
        </div>

        <div class="dt-modal--options">
          <!-- <button
            class="dt-button v4 s1"
            :class="{'disabled': !isFormValid}"
            :disabled="!isFormValid"
            @click.stop="login"
          >
            {{
            (!loginUser.success && !loginUser.loading) ? 'Login' : (
            (loginUser.loading && !loginUser.success) ? 'Loading' : (
            (loginUser.success && !loginUser.loading) ? 'Login Succesful' : (
            (loginUser.success && loginUser.loading) ? 'Login Succesful...loading' : '?'
            )
            )
            )
            }}
          </button>-->

          <!-- Validation Logic lifter from Button -->
          <!-- :class="{'disabled': !isFormValid}"
          :disabled="!isFormValid" -->

          <button
            class="dt-button v4 s1"
            @click.stop="login"
            :disabled="loginUser.loading || loginUser.success"
          >
            <span v-if="sharedLogin"> Login </span>
            <span v-else-if="!loginUser.success && !loginUser.loading"
              >Login</span
            >
            <span v-else-if="loginUser.loading && !loginUser.success"
              >Loading</span
            >
            <span v-else-if="loginUser.success && !loginUser.loading"
              >Login Successful</span
            >
            <span v-else>Login Successful...loading</span>
          </button>
        </div>
        <div style="text-align: center" class="password-reset">
          <a :href="recover_pw_url">Reset Password</a>
        </div>
      </v-card>
    </div>
    <ModalContainer :modalKey="'resetPassword'" :width="'small'">
      <QuickModal
        :title="'Reset Password'"
        :placeholder="'User Name / Email Address'"
        @cancelled="onModalCancelled"
        @ok="onResetPasswordSubmit"
      />
    </ModalContainer>
  </div>
</template>

<script>
// import TextField from "@plugins/text-field/text-field";
import { AuthenticationService } from "../services/authentication.service";

import * as ActionTypes from "../store/app/types";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { clientName } from "../services/http/http-client";

import QuickModal from "@plugins/quickmodal/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
} from "../dt-plugins/modal/modal.mixin";
import { NotificationService } from "../dt-plugins/notification/notification.service";
import { isChromium } from "../utility/platform";
import { lastValidRouteOrHome } from "../router/guard";

export default {
  components: {
    // TextField,
    QuickModal,
    ModalContainer,
  },
  mounted: async function () {
    const res = await AuthenticationService.resetPasswordURL();

    this.recover_pw_url = res.data.recover_pw_url;

    setTimeout(() => {
      this.setAutoFill();
    }, 500);
    setTimeout(() => {
      this.setAutoFill();
    }, 1000);

    this[ActionTypes.SET_LOGIN_USER]({
      loading: false,
      success: false,
    });

    // commit(types.SET_LOGIN_USER, {
    //     // password: [...getters.loginUser.password].map(l => 'B').join(''),
    //     loading: false,
    //     success: true
    //   });
  },
  mixins: [createModalMixin("resetPassword")],
  data: function () {
    return {
      recover_pw_url: "",
      user: {
        username: "",
        password: "",
      },
      validationResult: {},
      clientName: clientName,
    };
  },
  computed: {
    ...mapGetters({
      loginUser: "loginUser",
    }),
    sharedLogin: function () {
      return this.$route.name == "shared-login";
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    textFieldConfig: function () {
      return {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        // immediateValidation : isChromium() ? false : true,
      };
    },
  },
  methods: {
    ...mapActions({
      [ActionTypes.LOGIN]: ActionTypes.LOGIN,
    }),
    ...mapMutations({
      [ActionTypes.SET_LOGIN_USER]: ActionTypes.SET_LOGIN_USER,
    }),
    setAutoFill: function () {
      setTimeout(() => {
        // this.$refs?.["usernameTextfield"]?.$el?.focus();
      }, 200);

      // console.log("Log: this.$refs", this.$refs?.["usernameTextfield"]?.$el.focus);

      const username =
        this.$refs?.["usernameTextfield"]?.$el?.querySelector("input")?.value;
      const password =
        this.$refs?.["passwordTextfield"]?.$el?.querySelector("input")?.value;

      if (username && password) {
        this[ActionTypes.SET_LOGIN_USER]({
          username,
          password,
        });
      }
    },
    onTextFieldValueChange: function (key, value) {
      this[ActionTypes.SET_LOGIN_USER]({
        [key]: value,
      });
      if (!isChromium()) {
        this.setAutoFill();
      }
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    login: async function () {
      // console.log(this.user);
      if (!(this.loginUser.success || this.loginUser.loading)) {
        this[ActionTypes.LOGIN]();
      }
    },
    onResetPasswordClick: function () {
      openModalRoute(this, "reset_password");
    },
    onModalCancelled: function () {
      closeModalRoute(this);
    },
    onResetPasswordSubmit: async function (value) {
      // console.log(value);
      const resetRes = await AuthenticationService.resetPassword({
        user_name_email: value,
      });
      // console.log(resetRes);
      if (resetRes.data.found == 1) {
        NotificationService.showNotification({
          text: "The new password has been emailed to you",
          timeout: 5000,
        });
      } else {
        NotificationService.showNotification({
          text: "The username or Email was not found",
          timeout: 5000,
          type: "error",
        });
      }
      this.onModalCancelled();
    },

    loginAgain: async function () {
      await AuthenticationService.logoutSharedUser();
      const validRoute = lastValidRouteOrHome();
      console.log({ "login.vue:280 validRoute": validRoute });
      this.$router.push({
        path: validRoute,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://detailss3web.s3.amazonaws.com/images/toshbg2.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  height: 100%;
  .login-container {
    .login-card {
      flex: 1;
      width: 400px;

      background: linear-gradient(to top, #212121, #212121, #414141);
      color: white;
      --text-2: white;
      --sprt-2: white;
      --sprt-9: #333333;
      --text-5: white;

      .dt-modal--header {
        padding: 30px 20px;
      }

      .dt-modal--body {
        display: flex;
        flex-direction: column;
      }
      .password-reset {
        a {
          color: white;
        }
      }

      .company-logo {
        width: 100%;
        max-height: 120px;
        object-fit: contain;
      }

      .form-group {
        display: flex;
        flex-direction: column;
        .dt-input-box {
          flex: 1;
          margin: 10px;
          margin-left: 0px;
        }

        .group-input {
          margin-top: 25px;
          margin-bottom: 10px;
        }
      }
      .dt-modal--options {
        margin-top: 10px;
        button {
          height: 40px;
          margin: 10px 0px 15px 0px;
        }
      }
    }
  }
}
</style>
